import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Begrenze Debug-Logs, um Logcat nicht zu fluten
let netDbgCount = 0;

/**
 * Auth Interceptor - Shared between Web and Mobile
 * Adds Bearer token to all HTTP requests
 * Handles 401 errors by logging out user
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const router = inject(Router);

  // Token direkt aus Storage lesen, um DI-Zyklen mit AuthService zu vermeiden
  const token = (typeof window !== 'undefined' && typeof localStorage !== 'undefined')
    ? localStorage.getItem('token')
    : null;

  // Add Authorization header if token exists
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    tap(event => {
      // Logge nur wenige Requests auf Native (Logcat) für Diagnose
      const isNative = typeof window !== 'undefined' && !!(window as any).Capacitor?.isNativePlatform?.();
      if (!isNative) return;
      if (netDbgCount >= 8) return;
      if (event instanceof HttpResponse) {
        netDbgCount += 1;
        const contentType = event.headers?.get?.('Content-Type') || '';
        let bodyPreview = '';
        if (contentType && !contentType.includes('application/json')) {
          try {
            const raw = typeof event.body === 'string' ? event.body : JSON.stringify(event.body);
            bodyPreview = raw ? String(raw).slice(0, 180) : '';
          } catch {}
        }
        console.log('[NetDbg][HTTP]', event.status, event.url || '', 'ct=', contentType, bodyPreview ? 'body~=' + bodyPreview : '');
      }
    }),
    catchError((error: HttpErrorResponse) => {
      const isNative = typeof window !== 'undefined' && !!(window as any).Capacitor?.isNativePlatform?.();
      if (isNative) {
        const contentType = error.headers?.get?.('Content-Type') || '';
        console.log('[NetDbg][HTTP][ERR]', error.status, req.url || '', 'ct=', contentType);
      }
      // Handle 401 Unauthorized
      if (error.status === 401) {
        try {
          console.error('Auth interceptor 401 error body:', error.error);
        } catch (e) {
          console.error('Auth interceptor 401 (no body)');
        }
        // Clear auth and redirect to login
        try {
          const authService = injector.get(AuthService);
          authService.logout();
        } catch {
          if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
          }
          router.navigate(['/login']);
        }
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
